import IconButtonModule from './module';

import './index.scss';

export default IconButtonModule;
